import {Component, Input, output} from '@angular/core';
import {Activity} from "../../../models/activity.model";
import {DetailedViewObjectService} from "../../../services/detailed-view-object.service";
import { RdsIconComponent } from "@rds/angular-components";
import {ContextMenuService} from "../../../services/context-menu.service";
import {DataObject} from "../../../models/metadata";

@Component({
  selector: 'app-activity',
  standalone: true,
  imports: [
    RdsIconComponent,
  ],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss'
})
export class ActivityComponent {
  @Input() activity!: Activity
  deleteActivity = output<DataObject>()

  constructor(private detailedObjectService: DetailedViewObjectService, private contextMenuService: ContextMenuService) {
  }

  getStudiesWithName() {
    return this.activity.studies.filter(s => !!s.studyName)
  }

  onCardClick(){
    this.detailedObjectService.nextDetailedObject(this.activity)
  }

  onContextMenu(_: MouseEvent){
    this.contextMenuService.addItemToNextOpen('activity', () => {
      this.deleteActivity.emit(this.activity as DataObject)
    })
  }

  // Contrast helper duplicated from admin tables (could be refactored to shared util later)
  getContrastColor(hexColor?: string | null): string {
    const hex = (hexColor || '').replace('#','');
    if (hex.length !== 6) {
      return '#111827'; // default dark gray
    }
    const r = parseInt(hex.substring(0,2), 16);
    const g = parseInt(hex.substring(2,4), 16);
    const b = parseInt(hex.substring(4,6), 16);
    const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
    return luminance > 0.6 ? '#111827' : '#FFFFFF';
  }
}
